import firebase from '../config/FirebaseConfig'
import store from '@/store'

const db = firebase.firestore()

const getSavedFilters = async () => {
  const user = firebase.auth().currentUser

  if (!user) return []

  const userTeam = store.getters['AuthModule/getTeam']
  const ownerField = userTeam ? 'teamId' : 'createdBy'
  const ownerValue = userTeam?.id || user.uid

  const snapshot = await db.collection('saved-filters')
    .where(ownerField, '==', ownerValue)
    .orderBy('updatedAt', 'desc')
    .get()

  return snapshot.docs?.map(doc => {
    return {
      id: doc.id,
      ...doc.data() || []
    }
  })
}

const createSavedFilter = async (payload) => {
  const user = firebase.auth().currentUser

  if (!user) throw new Error('User not authenticated')

  const userTeam = store.getters['AuthModule/getTeam']
  const teamId = userTeam?.id

  return await db.collection('saved-filters').add({
    ...payload,
    createdBy: user.uid,
    createdAt: +new Date(),
    updatedAt: +new Date(),
    ...(teamId && { teamId })
  })
}

const updateSavedFilter = async (filterId, payload) => {
  const formattedPayload = { 
    ...payload, 
    updatedAt: +new Date() 
  }
  delete formattedPayload.id
  return await db.collection('saved-filters')
    .doc(filterId)
    .update(formattedPayload)
}

const deleteSavedFilter = async (filterId) => {
  return await db.collection('saved-filters')
    .doc(filterId)
    .delete()
}

export default {
  getSavedFilters,
  createSavedFilter,
  updateSavedFilter,
  deleteSavedFilter
}